import { z } from "zod";
import { isString } from "remeda";

export const addressTypeSchema = z.enum(["MAIN", "POSTAL", "MAIN_FOREIGN", "POSTAL_FOREIGN"]);

export const zipSchema = z.preprocess(value => (isString(value) ? value.split(" ").join("") : value), z.string());

export const addressSchema = z.object({
  addressPlaceCode: z.nullable(z.number()),
  street: z.preprocess(name => (name === null ? "" : name), z.string()),
  countryCode: z.preprocess(name => (typeof name === "string" ? name.toUpperCase() : ""), z.string()),
  houseNumber: z.preprocess(name => (name === null ? "" : name), z.string().or(z.number())),
  streetNumber: z.preprocess(name => (name === null ? "" : name), z.string()),
  parcelNumber: z.optional(z.nullable(z.string())),
  parcelPart: z.optional(z.nullable(z.string())),
  evidenceNumber: z.optional(z.nullable(z.string().or(z.number()))),
  city: z.preprocess(name => (name === null ? "" : name), z.string()),
  cityPart: z.preprocess(name => (name === null ? "" : name), z.string()),
  zip: zipSchema,
  cadastralTerritory: z.preprocess(name => (name === null ? "" : name), z.string()),
  cadastralTerritoryCode: z.number().nullable(),
  pobox: z.nullable(z.unknown()),
  nameCareOf: z.nullable(z.string()),
});

export const addressWithTypeSchema = z
  .object({
    type: addressTypeSchema,
  })
  .merge(addressSchema);

export const connectionPointAddressSchema = z.object({
  PostCode: z.string(),
  City: z.string(),
  CityPart: z.string(),
  Street: z.string(),
  HouseNum1: z.string(),
  HouseNum2: z.string(),
});
